import React from 'react';
import CustomDropdown from './CustomDropdown';

// Badge styling helper
const getBadgeClass = (type, value) => {
  if (type === 'priority') {
    switch (value?.toLowerCase()) {
      case 'critical': return 'text-red-400';
      case 'high': return 'text-red-400';
      case 'medium': return 'text-yellow-400';
      case 'low': return 'text-green-400';
      default: return 'text-gray-400';
    }
  }
  if (type === 'domain') {
    switch (value?.toLowerCase()) {
      case 'software': return 'text-purple-400';
      case 'electronics': return 'text-blue-400';
      case 'mechanical': return 'text-orange-400';
      case 'operations': return 'text-pink-400';
      default: return 'text-gray-400';
    }
  }
  if (type === 'status') {
    switch (value?.toLowerCase()) {
      // Simplified categories
      case 'not_decided': return 'text-gray-400';
      case 'in_progress': return 'text-blue-400';
      case 'hold': return 'text-yellow-400';
      case 'done': return 'text-green-400';
      // Individual status values (for backward compatibility)
      case 'new': return 'text-blue-400';
      case 'under_discussion': return 'text-yellow-400';
      case 'solution_decided': return 'text-indigo-400';
      case 'in progress': return 'text-blue-400';
      case 'completed': return 'text-green-400';
      case 'not decided': return 'text-gray-400';
      case 'pending': return 'text-blue-400';
      case 'solved': return 'text-green-400';
      default: return 'text-gray-400';
    }
  }
  return 'text-gray-400';
};

const BadgeDropdown = ({
  value,
  onChange,
  options,
  type, // 'priority', 'domain', or 'status'
  placeholder = "Select...",
  className = "",
  disabled = false,
  showAllOption = false
}) => {
  // Helper function to get correct plural form
  const getPlural = (type) => {
    switch (type) {
      case 'status': return 'statuses';
      case 'priority': return 'priorities';
      case 'domain': return 'domains';
      default: return `${type}s`;
    }
  };

  // Add "All" option if requested
  const allOptions = showAllOption
    ? [{ value: 'all', label: `All ${getPlural(type)}` }, ...options]
    : options;

  const renderBadge = (option) => {
    if (option.value === 'all') {
      return <span className="text-gray-300">{option.label}</span>;
    }

    const badgeClass = getBadgeClass(type, option.value);
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${badgeClass}`}>
        {option.label}
      </span>
    );
  };

  return (
    <CustomDropdown
      value={value}
      onChange={onChange}
      options={allOptions}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      renderOption={renderBadge}
      renderSelected={renderBadge}
    />
  );
};

export default BadgeDropdown;